export default __webpack_public_path__ + "4af62141753ce406ecef6cfa951e7a3e.png";